"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PromocodeInvalid = function (_a) {
    var onClose = _a.onClose;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "480px", height: "auto", portalNodeId: "modal", onClose: onClose, padding: Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? '25px 15px'
            : '40px', saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t.raw('promocodeDoesNotExistTitle'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text, dangerouslySetInnerHTML: {
                    __html: t.raw('promocodeDoesNotExistText'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.textColor, dangerouslySetInnerHTML: {
                    __html: t.raw('promocodeDoesNotExistAdditionalText'),
                } }),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: onClose, width: breakpoints.mobile ? '100%' : '320px', maxWidth: breakpoints.mobile ? '100%' : '320px' }, t('ok')))));
};
exports.default = PromocodeInvalid;
